export const environment = {
    production: false,
    ENV: 'test',
    SITE_URL: 'https://test.dotblack.co.za',
};
